import React from "react";
import { useSelector, useDispatch } from "react-redux";
import styled from "@emotion/styled";
import { Form, Input, Button } from "antd";

import { responsive } from "../../utils/style";
import { css } from "@emotion/react";
import "./login.css";
import Api from "../../utils/api";
import { useNavigate } from "react-router-dom";
import { onGetUserInfo } from "../../stores/auth";
import { FieldContainer } from "../../components/CustomFields";
import { passwordRegexp } from "../../utils/password";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [form] = Form.useForm();

  const onFinish = async (values) => {
    await Api.post("authen/login", values)
      .then((res) => {
        const token = res.data.accessToken;
        const refreshToken = res.data.refreshToken;
        localStorage.setItem("token", token);
        localStorage.setItem("refreshToken", refreshToken);
        dispatch(onGetUserInfo());
        navigate("/");
      })
      .catch((err) => {
        alert(err.response.data.message);
      });
  };

  return (
    <Container>
      <Background>
        <Title>เข้าสู่ระบบ</Title>
        <FormContainer>
          <Form
            form={form}
            name="login"
            layout="vertical"
            style={{ width: "100%" }}
            onFinish={onFinish}
            autoComplete="off"
            size="large"
          >
            <FieldContainer
              name="username"
              label="ชื่อผู้ใช้งาน (USERNAME)"
              required={false}
              rules={[{ required: true, message: "โปรดระบุ" }]}
              marginBottom={0}
            >
              <Input placeholder="โปรดระบุ" />
            </FieldContainer>

            <FieldContainer
              name="password"
              label="รหัสผ่าน"
              rules={[
                {
                  pattern: passwordRegexp,
                  message: `ประกอบด้วยตัวเลข (0-9) หรือตัวอักษรภาษาอังกฤษ(a-z)`,
                },
                { min: 8, message: "ต้องมีความยาวไม่น้อยกว่า 8 ตัวอักษร" },
              ]}
              hasFeedback
              marginBottom={0}
            >
              <Input.Password placeholder="โปรดระบุ" />
            </FieldContainer>
            <Form.Item shouldUpdate style={{ marginTop: "24px" }}>
              {() => (
                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={
                    !form.isFieldsTouched(true) ||
                    !!form
                      .getFieldsError()
                      .filter(({ errors }) => errors.length).length
                  }
                >
                  เข้าสู่ระบบ
                </Button>
              )}
            </Form.Item>
          </Form>
        </FormContainer>
        <Textlink href="/register">ลงทะเบียน</Textlink>
        <Textlink href="/resetPassword">ลืมรหัสผ่าน?</Textlink>
      </Background>
    </Container>
  );
};

const Textlink = styled.a`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  text-align: center;
  color: #4b5768;
`;

const Title = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 23px;
  line-height: 28px;
  color: #058459;
  margin-top: 40px;
`;

const Container = styled.div`
  width: 100%;
  background-color: #fffbeb;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Noto Sans Thai", "Noto Sans";
`;

const Background = styled.div`
  width: 100%;
  height: 100vh;
  max-width: 1144px;

  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;

  padding-bottom: 80px;

  span {
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    text-align: center;

    color: #4b5768;
  }

  ${responsive.tablet(css`
    max-width: 834px;
    padding-bottom: 50px;
  `)}

  ${responsive.mobile(css`
    max-width: 375px;
    padding-bottom: 40px;
  `)}
`;

const FormContainer = styled.div`
  margin: 40px 0 0 0;
  width: 60%;

  > form > div {
    margin-bottom: 24px;
  }

  ${responsive.mobile(css`
    width: 90%;
  `)}

  form label {
    font-style: normal;
    font-weight: 500;
    color: #4b5768;
    font-size: 21px;
    height: auto !important;
  }

  div {
    padding-bottom: 0;
  }

  span {
    text-align: left;
  }

  input {
    border-radius: 4px;
    font-size: 18px;
    border: 1px solid #a0abbb;
    box-sizing: border-box;
  }

  #login_username,
  .ant-input-password {
    height: 52px;
  }
`;
export default Login;
